/* eslint-disable react/jsx-no-target-blank */
import * as S from './styles';
import ChevronRight from 'components/Icons/ChevronRight';
import { BaseMain } from 'components/BaseMain';
import Button from 'components/Button';
import { Heading } from 'components/Heading';
import { Loading } from 'components/Loading';
import { MainHeader } from 'components/MainHeader';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InfoIcon } from 'components/Icons';
import { BaseContentMain } from 'components/BaseContentMain';

import { Banner } from 'components/Banner';
// import BuyPackage from 'components/Icons/BuyPackage';
import { QualificationContext } from 'contexts/AvailableQualification';
import moment from 'moment';
import 'moment/locale/pt-br';
import { api } from 'services/api';
import { ClientInfoContext } from 'contexts/ClientInfoContext';
import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { InvoiceStatus } from 'components/InvoiceStatus';
import ConsumptionDetails from './Drawer/ConsumptionDetails';
import { ComprarKoinsModal } from './ComprarKoinsModal';
import { AutoRecargaModal } from './AutoRecargaModal';
import {
  DetalhesDoPlanoDrawer,
  AdditionalPackage,
} from './DetalhesDoPlanoDrawer';
import CreditCard from 'components/Icons/CreditCard';

import {
  ErrorCircle,
  CheckmarkCircle,
} from 'styled-icons/fluentui-system-filled';
import { Add } from 'styled-icons/fluentui-system-regular';

// Função personalizada para arredondamento específico
export const customRoundCurrency = (value: number) => {
  try {
    if (Number.isNaN(Number(value))) {
      throw new Error('Invalid money value');
    }

    // Aplicar a regra de arredondamento específica
    const decimalPart = value % 1;
    let roundedValue = value;

    if (decimalPart >= 0.001 && decimalPart <= 0.005) {
      // 0,001 ~ 0,005 = arredondar pra baixo (0,00)
      roundedValue = Math.floor(value * 100) / 100;
    } else if (decimalPart >= 0.006 && decimalPart <= 0.009) {
      // 0,006 ~ 0,009 = arredondar pra cima (0,01)
      roundedValue = Math.ceil(value * 100) / 100;
    }

    const formatMoney = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
    return formatMoney.format(roundedValue).replace(/\s/, ' ');
  } catch (e: any) {
    return e.message;
  }
};

export type indicatorsProps = {
  mes: number;
  ano: number;
  qtd_total_envelopes: number;
  qtd_total_assinantes: number;
  qtd_total_documentos_assinados: number;
  perc_envelopes_assinados: number;
  atendimento?: number;
  editor?: number;
  motion?: number;
  blog?: number;
  pages?: number;
};
export type Iindicator = {
  id_cliente: number;
  id_sl: number;
  qtd_total_envelopes: number;
  qtd_total_assinantes: number;
  qtd_total_documentos_assinados: number;
  perc_envelopes_assinados: number;
  qtd_acessos_lia: number;
  qtd_imoveis_lia: number;
  qtd_leads_lia: number;
  qtd_omnichannel_lya: number;
  _id: string;
};
export type HistoryOfQualificationProps = {
  date: string;
  value: number;
  id_qualifier_package: number;
  id_qualifier_bought: string;
  type_transaction: string;
  transaction: string;
  qualififer_package: {
    id_qualifier_pack: string;
    name: string;
    type: number;
  };
  children: React.ReactNode;
};

export type DailyQualification = {
  date?: string;
  name_broker: string;
  name_client: string;
};

const complementItems: {
  id: number;
  icon: React.ReactNode;
  title: string;
  description: string;
}[] = [
  {
    id: 18,
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 2C13.1533 2 14.2391 2.28926 15.1888 2.79919C15.1125 3.245 14.9647 3.56044 14.7626 3.76256C14.652 3.87316 14.5074 3.96747 14.3259 4.04283C13.6241 3.69484 12.8348 3.5 12 3.5C9.10051 3.5 6.75 5.8505 6.75 8.75C6.75 10.8882 8.02822 12.7278 9.86222 13.5465C10.5503 13.815 11.1857 13.9625 11.7683 13.9937L12 14C12.6447 14 13.3575 13.8508 14.1372 13.5477C15.053 13.1384 15.8302 12.475 16.3789 11.6472C17.0183 11.8672 17.7877 11.7336 18.2728 11.2467C17.8577 12.2895 17.1902 13.2039 16.3459 13.9151L17.9673 18.7802C18.2336 19.5789 17.8933 20.4541 17.1573 20.8632C15.7856 21.6256 14.0643 22 12 22C9.93575 22 8.21443 21.6256 6.84269 20.8632C6.10675 20.4541 5.76645 19.579 6.0327 18.7802L7.65415 13.9151C6.18405 12.6769 5.25 10.8225 5.25 8.75C5.25 5.02208 8.27208 2 12 2ZM17.9924 1.88021L18 2C18 3.14961 18.2699 3.95921 18.7803 4.46967C19.2515 4.94087 19.9776 5.20706 20.9907 5.24522L21.25 5.25C22.2083 5.25 22.2483 6.6276 21.3698 6.7424L21.25 6.75C20.1004 6.75 19.2908 7.01987 18.7803 7.53033C18.3091 8.00153 18.0429 8.72761 18.0048 9.74072L18 10C18 11 16.5 11 16.5 10C16.5 8.85039 16.2301 8.04079 15.7197 7.53033C15.2485 7.05913 14.5224 6.79294 13.5093 6.75478L13.25 6.75C12.2917 6.75 12.2517 5.3724 13.1302 5.2576L13.25 5.25C14.3996 5.25 15.2092 4.98013 15.7197 4.46967C16.2301 3.95921 16.5 3.14961 16.5 2C16.5 1.04167 17.8776 1.00174 17.9924 1.88021Z'
          fill='#404040'
        />
      </svg>
    ),
    title: 'Oráculo',
    description:
      'Acompanhe em tempo real o interesse dos leads e foque nas melhores oportunidades.',
  },
  {
    id: 16,
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 2C13.1533 2 14.2391 2.28926 15.1888 2.79919C15.1125 3.245 14.9647 3.56044 14.7626 3.76256C14.652 3.87316 14.5074 3.96747 14.3259 4.04283C13.6241 3.69484 12.8348 3.5 12 3.5C9.10051 3.5 6.75 5.8505 6.75 8.75C6.75 10.8882 8.02822 12.7278 9.86222 13.5465C10.5503 13.815 11.1857 13.9625 11.7683 13.9937L12 14C12.6447 14 13.3575 13.8508 14.1372 13.5477C15.053 13.1384 15.8302 12.475 16.3789 11.6472C17.0183 11.8672 17.7877 11.7336 18.2728 11.2467C17.8577 12.2895 17.1902 13.2039 16.3459 13.9151L17.9673 18.7802C18.2336 19.5789 17.8933 20.4541 17.1573 20.8632C15.7856 21.6256 14.0643 22 12 22C9.93575 22 8.21443 21.6256 6.84269 20.8632C6.10675 20.4541 5.76645 19.579 6.0327 18.7802L7.65415 13.9151C6.18405 12.6769 5.25 10.8225 5.25 8.75C5.25 5.02208 8.27208 2 12 2ZM15.0566 14.7914L14.6969 14.9395L14.6788 14.9475C13.9523 15.262 13.1595 15.4525 12.3272 15.4922C12.321 15.4911 12.3153 15.4914 12.3096 15.4917C12.2858 15.4941 12.2614 15.4951 12.237 15.4959L12 15.5L11.804 15.496L11.6733 15.4908C10.8405 15.4525 10.0477 15.262 9.32116 14.9475L9.30307 14.9395C9.18403 14.893 9.06416 14.8436 8.94345 14.7914L7.45573 19.2545C7.41769 19.3686 7.46631 19.4937 7.57144 19.5521C8.70008 20.1794 10.174 20.5 12 20.5C13.826 20.5 15.2999 20.1794 16.4286 19.5521C16.5337 19.4937 16.5823 19.3686 16.5443 19.2545L15.0566 14.7914ZM11.6898 15.493L11.804 15.496L11.8373 15.4977L12 15.5C11.896 15.5 11.7926 15.4977 11.6898 15.493ZM17.9924 1.88021L18 2C18 3.14961 18.2699 3.95921 18.7803 4.46967C19.2515 4.94087 19.9776 5.20706 20.9907 5.24522L21.25 5.25C22.2083 5.25 22.2483 6.6276 21.3698 6.7424L21.25 6.75C20.1004 6.75 19.2908 7.01987 18.7803 7.53033C18.3091 8.00153 18.0429 8.72761 18.0048 9.74072L18 10C18 11 16.5 11 16.5 10C16.5 8.85039 16.2301 8.04079 15.7197 7.53033C15.2485 7.05913 14.5224 6.79294 13.5093 6.75478L13.25 6.75C12.2917 6.75 12.2517 5.3724 13.1302 5.2576L13.25 5.25C14.3996 5.25 15.2092 4.98013 15.7197 4.46967C16.2301 3.95921 16.5 3.14961 16.5 2C16.5 1.04167 17.8776 1.00174 17.9924 1.88021ZM17.25 4.95251L17.1063 5.15617C17.0063 5.28828 16.8976 5.41304 16.7803 5.53033C16.6044 5.70627 16.4116 5.86273 16.2025 6C16.4116 6.13727 16.6044 6.29373 16.7803 6.46967C16.9563 6.64561 17.1127 6.83835 17.25 7.04749C17.3873 6.83835 17.5437 6.64561 17.7197 6.46967C17.8956 6.29373 18.0884 6.13727 18.2975 6C18.0884 5.86273 17.8956 5.70627 17.7197 5.53033C17.6024 5.41304 17.4937 5.28828 17.3937 5.15617L17.25 4.95251Z'
          fill='#404040'
        />
      </svg>
    ),
    title: 'Editor',
    description:
      'Gere novas descrições otimizadas para seu público com um clique.',
  },
  {
    id: 17,
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.5 9.38455V14.6162C9.5 15.1858 10.1099 15.5475 10.6097 15.2743L15.3959 12.6582C15.9163 12.3737 15.9162 11.6263 15.3958 11.3419L10.6097 8.72641C10.1099 8.45328 9.5 8.81499 9.5 9.38455ZM7.25 1C5.45507 1 4 2.45507 4 4.25V19.75C4 21.5449 5.45507 23 7.25 23H16.75C18.5449 23 20 21.5449 20 19.75V4.25C20 2.45507 18.5449 1 16.75 1H7.25ZM5.5 4.25C5.5 3.2835 6.2835 2.5 7.25 2.5H16.75C17.7165 2.5 18.5 3.2835 18.5 4.25V19.75C18.5 20.7165 17.7165 21.5 16.75 21.5H7.25C6.2835 21.5 5.5 20.7165 5.5 19.75V4.25Z'
          fill='#404040'
        />
      </svg>
    ),
    title: 'Studio',
    description: 'Crie imagens e vídeos a partir das fotos dos seus imóveis.',
  },
  {
    id: 19,
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M18 20.5H12.2678C11.9806 21.051 11.6168 21.5557 11.1904 22H18C19.104 22 20 21.104 20 20V9.828C20 9.298 19.789 8.789 19.414 8.414L13.585 2.586C13.57 2.57105 13.5531 2.55808 13.5363 2.5452C13.5238 2.53567 13.5115 2.5262 13.5 2.516C13.429 2.452 13.359 2.389 13.281 2.336C12.937 2.152 12.74 2.07 12.528 2.029 12.313 2.014C12.172 2H6C4.896 2 4 2.896 4 4V11.4982C4.47417 11.3004 4.97679 11.1572 5.5 11.0764V4C5.5 3.725 5.724 3.5 6 3.5H12V8C12 9.104 12.896 10 14 10H18.5V20C18.5 20.275 18.276 20.5 18 20.5ZM17.378 8.5H14C13.724 8.5 13.5 8.275 13.5 8V4.621L17.378 8.5ZM12 17.5C12 20.5376 9.53757 23 6.5 23C3.46243 23 1 20.5376 1 17.5C1 14.4624 3.46243 12 6.5 12C9.53757 12 12 14.4624 12 17.5ZM9.85355 15.1464C9.65829 14.9512 9.34171 14.9512 9.14645 15.1464L5.5 18.7929L3.85355 17.1464C3.65829 16.9512 3.34171 16.9512 3.14645 17.1464C2.95118 17.3417 2.95118 17.6583 3.14645 17.8536L5.14645 19.8536C5.34171 20.0488 5.65829 20.0488 5.85355 19.8536L9.85355 15.8536C10.0488 15.6583 10.0488 15.3417 9.85355 15.1464Z'
          fill='#404040'
        />
      </svg>
    ),
    title: 'KIB',
    description:
      'Unifique dados de diferentes fontes e garanta um anúncio sempre atualizado.',
  },
];

const categories = [
  { name: 'SDR', color: '#B5E4FF', key: 'qtd_sdr_lya' },
  { name: 'Omnichannel', color: '#7CAEF1', key: 'qtd_omnichannel_lya' },
  { name: 'Oráculo', color: '#1F3A8A', key: 'qtd_oraculo_lya' },
  { name: 'Editor', color: '#514180', key: 'qtd_editor_lya' },
  { name: 'Studio', color: '#C876F2', key: 'qtd_studio_lya' },
  { name: 'KIB', color: '#F1C0FF', key: 'qtd_kib_lya' },
];
export const LIA = () => {
  const [indicatorsPerPage, setIindicatorsPerPage] = useState(3);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [indicators, setIndicators] = useState<indicatorsProps[]>([]);
  const history = useCustomUtilsHistory();
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const [indicatorSelected, setIndicatorSelected] = useState<any>();
  const [infoQualifier, setinfoQualifier] = useState<any>();
  const [LIAdata, setLIAdata] = useState<any>(null);
  const [infoToBanner, setInfoToBanner] = useState<any>();
  const [isLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isComprarKoinsOpen, setIsComprarKoinsOpen] = useState(false);
  const [isAutoRecargaOpen, setIsAutoRecargaOpen] = useState(false);
  const [isDetalhesPlanoOpen, setIsDetalhesPlanoOpen] = useState(false);
  const [omnichannelStatus, setOmnichannelStatus] = useState<
    'active' | 'inactive' | 'unavailable'
  >('unavailable');
  const [sdrStatus, setSdrStatus] = useState<
    'active' | 'inactive' | 'unavailable'
  >('unavailable');

  const [activeComplementIds, setActiveComplementIds] = useState<number[]>([]);

  const [autoRechargeData, setAutoRechargeData] = useState<{
    trigger_balance: number;
    tier_koin_quantity: number;
    tier_price: number;
    card_brand: string;
    card_last4: string;
  } | null>(null);
  const [pendingKoins, setPendingKoins] = useState<number | null>(null);
  const [additionalPackages, setAdditionalPackages] = useState<
    AdditionalPackage[]
  >([]);

  const { id } = useParams<{
    id: string;
  }>();
  const { dataClientInfo } = useContext(ClientInfoContext);

  const showMoreIndicators = () => {
    setIindicatorsPerPage(indicatorsPerPage => indicatorsPerPage + 3);
  };

  const { dataQualifierBalance, fetchDataQualifierBalance } =
    useContext(QualificationContext);

  useEffect(() => {
    if (
      dataClientInfo?.accessTokenParam &&
      infoQualifier?.contract_balance_product
    ) {
      fetchDataQualifierBalance(
        dataClientInfo?.accessTokenParam,
        dataClientInfo?.idTokenParams,
        infoQualifier?.contract_balance_product,
      );
    }
  }, [
    dataClientInfo?.accessTokenParam,
    fetchDataQualifierBalance,
    dataClientInfo?.idTokenParams,
    dataClientInfo?.id_realstate,
    infoQualifier?.contract_balance_product,
  ]);

  const disableButtonVerMaisIndicators = useMemo(() => {
    return indicatorsPerPage >= indicators.length;
  }, [indicatorsPerPage, indicators]);

  function capitalize(str: any): string {
    if (typeof str === 'string') {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      return '';
    }
  }

  const fetchDataIndicadores = async () => {
    try {
      const { data } = await api.get(`client/indicadores/client`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      const qualificationIndicatorsData = data.data.historia;
      setIndicators(
        qualificationIndicatorsData.sort((a: any, b: any) => {
          if (b.ano === a.ano) {
            return b.mes - a.mes;
          } else {
            return b.ano - a.ano;
          }
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDataIndicadores();
  }, [accessToken, id, idToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchComplementaryProducts = async () => {
    try {
      const { data } = await api.get('products', {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      setinfoQualifier(data.data.find((el: any) => el.id === 11));

      const sdrComplement = data?.data?.find((item: any) => item.id === 13);
      if (!sdrComplement) {
        setSdrStatus('unavailable');
      } else if (sdrComplement.using) {
        setSdrStatus('active');
      } else {
        setSdrStatus('inactive');
      }

      const omnichannelProduct = data.data.find((item: any) => item.id === 14);
      if (!omnichannelProduct) {
        setOmnichannelStatus('unavailable');
      } else if (omnichannelProduct.using) {
        setOmnichannelStatus('active');
      } else {
        setOmnichannelStatus('inactive');
      }

      const complementProductIds = [16, 17];
      const activeIds = complementProductIds.filter(id =>
        data.data.find((item: any) => item.id === id && item.using),
      );
      setActiveComplementIds(activeIds);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchComplementaryProducts();
  }, [accessToken, idToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchSignatureDetails = async () => {
    if (!infoQualifier?.id_signature) return;
    try {
      const { data } = await api.get(
        `client/signatures/${infoQualifier?.id_signature}`,
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      const LIA = data.data.signature_products.find(
        (sig: any) =>
          sig.product.sub_category === infoQualifier?.externalFamily,
      );
      if (LIA) setLIAdata(LIA);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSignatureDetails();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accessToken,
    idToken,
    infoQualifier?.id_signature,
    infoQualifier?.externalFamily,
  ]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const fetchAutoRechargeConfig = async () => {
    if (!dataClientInfo?.id_realstate) return;
    try {
      const headers = { Authorization: `Bearer ${accessToken}`, idToken };
      const [configRes, tiersRes, pmRes] = await Promise.all([
        api.get(`lya/auto-recharge`, {
          headers,
        }),
        api.get('lya/koin-tiers', { headers }),
        api.get(`lya/payment-methods`, {
          headers,
        }),
      ]);
      const config = configRes.data.data;
      if (config?.enabled) {
        const tier = tiersRes.data.data.tiers.find(
          (t: any) => t.id === config.id_tier,
        );
        const pm = pmRes.data.data.find(
          (p: any) =>
            p.stripe_payment_method_id === config.stripe_payment_method_id,
        );
        setAutoRechargeData({
          trigger_balance: config.trigger_balance,
          tier_koin_quantity: tier?.koin_quantity ?? 0,
          tier_price: tier?.total_price_brl ?? 0,
          card_brand: pm?.brand ?? '',
          card_last4: pm?.last4 ?? '',
        });
      } else {
        setAutoRechargeData(null);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchAutoRechargeConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClientInfo?.id_realstate]);

  const fetchCreditErrorSummary = async () => {
    try {
      const { data } = await api.get('lya/buy/credit-error-summary', {
        headers: { Authorization: `Bearer ${accessToken}`, idToken },
      });
      const koins = data?.data?.total_koin_quantity ?? null;
      setPendingKoins(koins && koins > 0 ? koins : null);
    } catch {
      // silent
    }
  };

  useEffect(() => {
    fetchCreditErrorSummary();
  }, [accessToken, idToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchAdditionalCredits = async () => {
    try {
      const { data } = await api.get(
        `qualifier/credit/additional-credits-balance`,
        {
          headers: { Authorization: `Bearer ${accessToken}`, idToken },
          params: { type_product: infoQualifier?.contract_balance_product },
        },
      );
      setAdditionalPackages(data?.data ?? []);
    } catch {
      setAdditionalPackages([]);
    }
  };

  useEffect(() => {
    fetchAdditionalCredits();
  }, [accessToken, idToken, infoQualifier?.contract_balance_product]); // eslint-disable-line react-hooks/exhaustive-deps

  const refetchAllRef = useRef<(() => void) | null>(null);
  refetchAllRef.current = () => {
    fetchDataIndicadores();
    fetchComplementaryProducts();
    fetchSignatureDetails();
    fetchBillingDetails();
    fetchAutoRechargeConfig();
    fetchCreditErrorSummary();
    fetchAdditionalCredits();
    if (
      dataClientInfo?.accessTokenParam &&
      infoQualifier?.contract_balance_product
    ) {
      fetchDataQualifierBalance(
        dataClientInfo.accessTokenParam,
        dataClientInfo.idTokenParams,
        infoQualifier.contract_balance_product,
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => refetchAllRef.current?.(), 60_000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getBodyPerformance = () => {
    const calculateBarSegments = (indicator: any) => {
      const total = indicator.qtd_total_lya || 0;
      if (total === 0) return [];

      return categories.map(cat => {
        const value = indicator[cat.key] || 0;
        return {
          ...cat,
          value,
          percentage: total > 0 ? (value / total) * 100 : 0,
        };
      });
    };

    return (
      <S.ContentConsumption>
        {indicators?.slice(0, indicatorsPerPage).map((indicator: any) => {
          const segments = calculateBarSegments(indicator);
          const totalKoins = indicator.qtd_total_lya || 0;

          return (
            <S.ConsumptionCard
              key={`${indicator.mes}-${indicator.ano}`}
              onClick={async () => {
                await setIndicatorSelected(indicator);
                setIsOpenDetails(true);
              }}
            >
              <S.ConsumptionCardHeader>
                <S.ConsumptionSubtitle>
                  {indicator.mes === moment().month() + 1
                    ? 'Este mês'
                    : capitalize(
                        `${moment(`${indicator.ano}-${indicator.mes}-01`, [
                          'YYYY-M-DD',
                          'YYYY-MM-DD',
                        ]).format('MMMM')} de ${indicator.ano}`,
                      )}
                </S.ConsumptionSubtitle>
                <S.ConsumptionTotal>{totalKoins} koins</S.ConsumptionTotal>
              </S.ConsumptionCardHeader>
              <S.ConsumptionBarChart>
                {!isMobile &&
                  segments.map((segment, index) => (
                    <S.ConsumptionBarSegment
                      key={index}
                      width={segment.percentage}
                      color={segment.color}
                    />
                  ))}
              </S.ConsumptionBarChart>
              <ChevronRight />
            </S.ConsumptionCard>
          );
        })}
        {!disableButtonVerMaisIndicators && (
          <S.WrapperButtonVerMais>
            <Button
              onClick={showMoreIndicators}
              disabled={disableButtonVerMaisIndicators}
            >
              Ver mais
            </Button>
          </S.WrapperButtonVerMais>
        )}
      </S.ContentConsumption>
    );
  };
  const fetchBillingDetails = async () => {
    if (!infoQualifier?.id_signature) return;
    try {
      const { data } = await api.get(
        `client/billings/signature/${infoQualifier?.id_signature}`,
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setInfoToBanner(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBillingDetails();
  }, [accessToken, idToken, infoQualifier?.id_signature]); // eslint-disable-line react-hooks/exhaustive-deps

  const exceedingEnvelopes = useMemo(() => {
    return dataQualifierBalance?.balance_premium &&
      dataQualifierBalance?.balance_premium < 0
      ? dataQualifierBalance?.balance_premium * -1
      : 0;
  }, [dataQualifierBalance?.balance_premium]);

  return (
    <>
      <MainHeader />
      <SubHeader
        title='Detalhes do Produto'
        onReturn={() => history.push('/ClientArea')}
      />
      {!isLoading && <Loading />}
      <BaseMain hideHeader>
        <S.BodyContentWrapper>
          <S.WrapperAside>
            <S.contentAside>
              {/* Header: title + status */}
              <S.TitleAside>
                <span className='title'>Lya</span>
                <InvoiceStatus
                  status={infoQualifier?.status ? 'paga' : 'cancelada'}
                  text={infoQualifier?.status ? 'Ativo' : 'Suspenso'}
                />
              </S.TitleAside>

              {/* Koins disponíveis label + chevron */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: '8px',
                  cursor: 'pointer',
                }}
                onClick={() => setIsDetalhesPlanoOpen(true)}
              >
                <div>
                  <S.TextAside>Koins disponíveis</S.TextAside>
                  <S.TextAside
                    fontSize='32'
                    fontWeight='700'
                    style={{ marginTop: '4px', display: 'block' }}
                  >
                    {(
                      dataQualifierBalance?.balance_premium ?? 0
                    ).toLocaleString('pt-BR')}
                  </S.TextAside>
                </div>
                <ChevronRight />
              </div>

              {/* Saldo do plano row */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '24px',
                }}
              >
                <S.TextAside fontSize='16' color='#808080'>
                  Saldo do plano
                </S.TextAside>
                <S.TextAside fontSize='16'>
                  {(dataQualifierBalance?.balance_contract ?? 0).toLocaleString(
                    'pt-BR',
                  )}
                  <span style={{ color: '#808080' }}>
                    {' '}
                    /
                    {(
                      LIAdata?.product?.qty_leads ??
                      LIAdata?.amount ??
                      0
                    ).toLocaleString('pt-BR')}
                  </span>
                </S.TextAside>
              </div>

              {/* Koins adicionais row (only when > 0) */}
              {(dataQualifierBalance?.balance_premium ?? 0) -
                (dataQualifierBalance?.balance_contract ?? 0) >
                0 && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '4px',
                  }}
                >
                  <S.TextAside fontSize='16' color='#808080'>
                    Koins adicionais
                  </S.TextAside>
                  <S.TextAside fontSize='16'>
                    {(
                      (dataQualifierBalance?.balance_premium ?? 0) -
                      (dataQualifierBalance?.balance_contract ?? 0)
                    ).toLocaleString('pt-BR')}
                  </S.TextAside>
                </div>
              )}

              {/* Pending koins banner */}
              {pendingKoins !== null && (
                <div
                  style={{
                    background: '#FFF8EE',
                    border: '1px solid #FDDCB4',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    marginTop: '16px',
                  }}
                >
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    style={{ flexShrink: 0, marginTop: '1px' }}
                  >
                    <circle
                      cx='10'
                      cy='10'
                      r='9'
                      stroke='#F59E0B'
                      strokeWidth='1.5'
                    />
                    <path
                      d='M10 5.5V10.5L13 12'
                      stroke='#F59E0B'
                      strokeWidth='1.5'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#1a1a1a',
                      lineHeight: '1.5',
                    }}
                  >
                    Estamos processando{' '}
                    <strong>
                      {pendingKoins.toLocaleString('pt-BR')} koins
                    </strong>
                    . Eles ficarão disponíveis em breve.
                  </span>
                </div>
              )}

              {/* Comprar Koins button */}
              <button
                onClick={() => setIsComprarKoinsOpen(true)}
                style={{
                  width: '100%',
                  margin: '24px 0 ',

                  background: 'transparent',
                  color: '#E0234E',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 700,
                  fontSize: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <Add size={24} /> Comprar koins
              </button>
              <hr
                style={{
                  marginLeft: '-24px',
                  marginRight: '-24px',
                  marginBottom: '24px',
                }}
              />
              {/* Auto-recharge section */}
              {autoRechargeData ? (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '12px',
                    }}
                  >
                    <span style={{ fontWeight: 700, fontSize: '16px' }}>
                      Recarga automática
                    </span>
                    <button
                      onClick={() => setIsAutoRecargaOpen(true)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#E0234E',
                        fontWeight: 700,
                        cursor: 'pointer',
                        fontSize: '16px',
                      }}
                    >
                      Editar
                    </button>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: '16px',
                      marginBottom: '8px',
                    }}
                  >
                    <div>
                      <div style={{ fontSize: '12px', color: '#808080' }}>
                        Quando o saldo for inferior a
                      </div>
                      <div style={{ fontSize: '16px', fontWeight: 500 }}>
                        {autoRechargeData.trigger_balance} koins
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#808080' }}>
                        Adicionar o pacote de
                      </div>
                      <div style={{ fontSize: '16px', fontWeight: 500 }}>
                        {autoRechargeData.tier_koin_quantity} koins
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#808080' }}>
                      Valor
                    </div>
                    <div style={{ fontSize: '20px', fontWeight: 600 }}>
                      {customRoundCurrency(autoRechargeData.tier_price)}
                    </div>
                  </div>
                  <div
                    style={{
                      borderRadius: '12px',
                      border: '1px solid #e0e0e0',
                      padding: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    <CreditCard />
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#808080',
                          fontWeight: 500,
                        }}
                      >
                        Cartão de crédito
                      </div>
                      <div style={{ fontSize: '16px', fontWeight: 500 }}>
                        {autoRechargeData.card_brand} ••••{' '}
                        {autoRechargeData.card_last4}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <button
                  onClick={() => setIsAutoRecargaOpen(true)}
                  style={{
                    width: '100%',

                    background: 'transparent',
                    color: '#E0234E',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 700,
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                  }}
                >
                  <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16 8.25C16 7.83579 16.3358 7.5 16.75 7.5C17.1642 7.5 17.5 7.83579 17.5 8.25V11.5C17.5 11.9142 17.1642 12.25 16.75 12.25H14C13.5858 12.25 13.25 11.9142 13.25 11.5C13.25 11.0858 13.5858 10.75 14 10.75H15.2705C14.7674 9.43442 13.4924 8.5 12.0001 8.5C10.907 8.5 9.96324 8.96361 9.32682 9.72938C9.06206 10.0479 8.5892 10.0916 8.27064 9.8268C7.95208 9.56205 7.90846 9.08918 8.17321 8.77062C9.09595 7.66036 10.4632 7 12.0001 7C13.636 7 15.0879 7.78531 16 8.99955V8.25ZM8 15V15.75C8 16.1642 7.66421 16.5 7.25 16.5C6.83579 16.5 6.5 16.1642 6.5 15.75V12.75C6.5 12.3358 6.83579 12 7.25 12H10C10.4142 12 10.75 12.3358 10.75 12.75C10.75 13.1642 10.4142 13.5 10 13.5H8.83669C9.39859 14.6829 10.6047 15.5 12.0001 15.5C13.0707 15.5 14.0368 15.0204 14.6786 14.2655C14.9469 13.9499 15.4202 13.9115 15.7358 14.1798C16.0514 14.4481 16.0897 14.9214 15.8214 15.237C14.9041 16.316 13.5252 17 12.0001 17C10.3638 17 8.91194 16.2143 8 15ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z'
                      fill='#F82E52'
                    />
                  </svg>
                  Ativar recarga automática
                </button>
              )}
            </S.contentAside>
          </S.WrapperAside>
          <S.WrapperMain>
            {infoToBanner && (
              <>
                {moment(infoToBanner.dueDate).isBefore(
                  moment
                    .tz(new Date(), 'America/Sao_Paulo')
                    .subtract(10, 'days'),
                ) ? (
                  <S.WrapperBanner>
                    <Banner
                      icon={<InfoIcon color='#6C2B22' />}
                      style={{
                        display: 'flex',
                        backgroundColor: '#FAE3E0',
                        color: '#6C2B22',
                        justifyContent: 'space-between',
                      }}
                      text={`Última fatura pendente! Para evitar o cancelamento da sua assinatura, realize o pagamento o quanto antes.`}
                    />
                  </S.WrapperBanner>
                ) : (
                  <S.WrapperBanner>
                    <Banner
                      icon={<InfoIcon />}
                      text={`Última fatura pendente! Entre em contato com o suporte em caso de problemas com o boleto.`}
                    />
                  </S.WrapperBanner>
                )}
              </>
            )}
            <S.contentAside>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '16px',
                }}
              >
                <S.TextAside fontSize='20' fontWeight='700'>
                  Atendimento da Lya
                </S.TextAside>
                <a
                  href='#'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: '#E0234E',
                    fontWeight: 700,
                    fontSize: '16px',
                    textDecoration: 'none',
                  }}
                >
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M9.33333 2H14V6.66667M14 2L8 8M6.66667 3.33333H3.33333C2.59695 3.33333 2 3.93029 2 4.66667V12.6667C2 13.403 2.59695 14 3.33333 14H11.3333C12.0697 14 12.6667 13.403 12.6667 12.6667V9.33333'
                      stroke='#E0234E'
                      strokeWidth='1.5'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                  Gerenciar
                </a>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '16px',
                }}
              >
                {/* Omnichannel */}

                <div
                  style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
                >
                  {omnichannelStatus === 'active' ? (
                    <CheckmarkCircle
                      size={24}
                      color='#27AE60'
                      style={{ marginBottom: '6px' }}
                    />
                  ) : (
                    <ErrorCircle
                      size={24}
                      color='#E0234E'
                      style={{ marginBottom: '6px' }}
                    />
                  )}
                  <div>
                    <S.TextAside fontSize='16' fontWeight='700'>
                      {omnichannelStatus === 'active'
                        ? 'Omnichannel ativo'
                        : omnichannelStatus === 'inactive'
                          ? 'Omnichannel inativo'
                          : 'Omnichannel indisponível'}
                    </S.TextAside>

                    <S.TextAside fontSize='12' color='#808080'>
                      {omnichannelStatus === 'active'
                        ? 'Converse com os leads sem sair do CRM'
                        : omnichannelStatus === 'inactive'
                          ? 'Configure o Omnichannel pelo painel dentro do Kenlo Imob.'
                          : 'Entre em contato com o time Kenlo para saber mais.'}
                    </S.TextAside>
                  </div>
                </div>
                {/* SDR */}
                <div
                  style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
                >
                  {sdrStatus === 'active' ? (
                    <CheckmarkCircle
                      size={24}
                      color='#27AE60'
                      style={{ marginBottom: '6px' }}
                    />
                  ) : (
                    <ErrorCircle
                      size={24}
                      color='#E0234E'
                      style={{ marginBottom: '6px' }}
                    />
                  )}
                  <div>
                    <S.TextAside fontSize='16' fontWeight='700'>
                      {sdrStatus === 'active'
                        ? 'SDR está ativo'
                        : sdrStatus === 'inactive'
                          ? 'SDR está inativo'
                          : 'SDR indisponível'}
                    </S.TextAside>
                    <S.TextAside fontSize='12' color='#808080'>
                      {sdrStatus === 'active'
                        ? 'Deixe a Lya agendar suas próximas visitas'
                        : sdrStatus === 'inactive'
                          ? 'Configure a Lya pelo painel dentro do Kenlo Imob.'
                          : 'Entre em contato com o time Kenlo para saber mais.'}
                    </S.TextAside>
                  </div>
                </div>
              </div>
            </S.contentAside>

            {activeComplementIds.length > 0 && (
              <S.contentAside>
                <S.TextAside
                  fontSize='20'
                  fontWeight='700'
                  style={{ marginBottom: '16px' }}
                >
                  Seus complementos
                </S.TextAside>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '12px',

                    border: '1px solid #F0F0F0',
                  }}
                >
                  {complementItems
                    .filter(item => activeComplementIds.includes(item.id))
                    .map((item, i, arr) => (
                      <div
                        key={item.title}
                        style={{
                          display: 'flex',
                          gap: '16px',
                          alignItems: 'center',
                          padding: '16px 24px',
                          borderBottom:
                            i < arr.length - 1 ? '1px solid #F0F0F0' : 'none',
                        }}
                      >
                        {item.icon}
                        <div>
                          <S.TextAside fontSize='16' fontWeight='700'>
                            {item.title}
                          </S.TextAside>
                          <S.TextAside
                            fontSize='12'
                            color='#808080'
                            fontWeight='500'
                          >
                            {item.description}
                          </S.TextAside>
                        </div>
                      </div>
                    ))}
                </div>
              </S.contentAside>
            )}

            <BaseContentMain
              padding='2.4rem 2.4rem 2.4rem 2.4rem'
              title={
                <S.WrapperTitle
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  <Heading
                    title='Consumo mensal'
                    weight='600'
                    size='large'
                    color='#1A1A1A'
                  />
                  {!isMobile && (
                    <S.ConsumptionLegend>
                      {categories.map(cat => (
                        <S.LegendItem key={cat.key}>
                          <S.LegendDot color={cat.color} />
                          <S.LegendText>{cat.name}</S.LegendText>
                        </S.LegendItem>
                      ))}
                    </S.ConsumptionLegend>
                  )}
                </S.WrapperTitle>
              }
            >
              {<>{getBodyPerformance()}</>}
            </BaseContentMain>
          </S.WrapperMain>
        </S.BodyContentWrapper>
      </BaseMain>
      {isOpenDetails && (
        <ConsumptionDetails
          closeDrawer={() => setIsOpenDetails(false)}
          indicator={indicatorSelected}
          idConsumption={dataClientInfo?.id_realstate}
          typeProduct={infoQualifier?.contract_balance_product}
          exceedingEnvelopes={exceedingEnvelopes}
        />
      )}
      {isComprarKoinsOpen && (
        <ComprarKoinsModal
          isOpen={true}
          onClose={() => setIsComprarKoinsOpen(false)}
          accessToken={accessToken}
          idToken={idToken}
        />
      )}
      {isAutoRecargaOpen && (
        <AutoRecargaModal
          isOpen={true}
          onClose={() => {
            setIsAutoRecargaOpen(false);
            fetchAutoRechargeConfig();
          }}
          accessToken={accessToken}
          idToken={idToken}
        />
      )}
      {isDetalhesPlanoOpen && (
        <DetalhesDoPlanoDrawer
          isOpen={true}
          onClose={() => setIsDetalhesPlanoOpen(false)}
          planName={LIAdata?.product?.name ?? ''}
          planValue={infoQualifier?.installmentValue ?? 0}
          planFrequency={infoQualifier?.planFrequency ?? 'mensal'}
          activationDate={dataClientInfo?.dgLeadsActivationDate}
          planLimit={LIAdata?.product?.qty_leads ?? LIAdata?.amount ?? 0}
          balanceContract={dataQualifierBalance?.balance_contract ?? 0}
          additionalPackages={additionalPackages}
        />
      )}
    </>
  );
};
